<style lang="scss" scoped>
.scroll {
  height: 90%;
  overflow: auto;
}
.artWork {
  background-color: #fff;
  height: 100%;
  width: 100%;
}
.wrapper {
  margin: auto;
  margin-top: 50px;
  width: 90%;
}
.logout {
  cursor: pointer;
}
.box {
  margin-top: 50px;
  width: 100%;
}
form {
  overflow: scroll;
  // max-height: 800px;
}

.panel-block {
  text-align: left;
   &:hover {
    text-decoration: none;
  }
  &.is-active {
    background: black;
    color: #fff !important;
    .art-date {
      color: #fff;
    }
  }
}
.art-date {
  color: #000;
  font-size: 12px;
}
.search {
  margin: 10px 0;
}
</style>

<template>
  <div class="artWork has-navbar-fixed-top">
    <div class="wrapper height-100">
      <Header />
      <div class="frow height-100 scroll">
        <div class="box height-100">
          <div class="frow gutters height-100">
            <div class="col-md-1-3 height-100">
              <nav class="panel height-100">
                <p class="panel-heading">
                  Art
                </p>
                <div class="frow mt-5 mb-5">
                  <button @click="showNewArtModal = true">
                    Add New Art
                  </button>
                  <div class="frow">
                    <input
                      v-model="search"
                      class="input search"
                      placeholder="Search Art..."
                    >
                    <div class="field frow">
                      <div class="col-1-2">
                        <label
                          class="checkbox reset frow mt-20 ml-10"
                        >
                          <div class="frow justify-start">
                            <input
                              v-model="missingParent"
                              type="checkbox"
                            >
                            has no parent story
                          </div>
                        </label>
                      </div>
                      <div class="col-1-2">
                        <label
                          class="checkbox reset frow mt-20 ml-10"
                        >
                          <div class="frow justify-start">
                            <input
                              v-model="missingLink"
                              type="checkbox"
                            >
                            has no link
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="scroll">
                  <a
                    v-for="art in filteredArt"
                    :key="art.id"
                    :class="{'is-active': activeArt.id == art.id}"
                    class="panel-block frow"
                    @click.prevent="setActiveArt(art); activeTab = 'artInfo'"
                  >
                    {{ art.title }}&nbsp;
                    <span class="art-date"> 
                      [{{ $moment(art.date).format("MM/DD/YYYY") }}]
                    </span>
                  </a>
                </div>
              </nav>
              <button @click="showNewArtModal = true">
                Add New Art
              </button>
            </div>
            <div class="col-md-2-3">
              <div v-if="activeArt">
                <h1>{{ activeArt.title }}</h1>
                <div class="tabs">
                  <ul>
                    <li
                      :class="{'is-active': activeTab == 'artInfo'}"
                      @click="activeTab = 'artInfo'"
                    >
                      <a>
                        Art Info
                      </a>
                    </li>
                    <!-- <li
                      :class="{'is-active': activeTab == 'steps'}"
                      @click="activeTab = 'steps'"
                    >
                      <a>
                        Steps
                      </a>
                    </li> -->
                    <li
                      :class="{'is-active': activeTab == 'deleteArt'}"
                      @click="activeTab = 'deleteArt'"
                    >
                      <a>
                        Delete Art
                      </a>
                    </li>
                  </ul>
                </div>
                <ArtForm
                  v-if="activeTab == 'artInfo' && !showNewArtModal"
                  :art="activeArt"
                  @saved="getArt()"
                />
                <!-- <ArtSteps
                  v-if="activeTab == 'steps'"
                  :steps.sync="activeArt.steps"
                  :art="activeArt"
                /> -->
                <DeleteArt
                  v-if="activeTab == 'deleteArt'"
                  :art="activeArt"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewArtModal
      v-if="showNewArtModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ArtForm from '@/components/Art/ArtForm.vue';
import DeleteArt from '@/components/Art/DeleteArt.vue';
import NewArtModal from '@/components/Art/NewArtModal.vue';
import Header from '@/components/Header.vue';

export default {
  name: 'ArtWork',
  components: {
    ArtForm,
    DeleteArt,
    NewArtModal,
    Header,
  },
  data() {
    return {
      activeTab: 'artInfo',
      artWork: null,
      showNewArtModal: false,
      search: null,
      missingParent: false,
      missingLink: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      activeArt: (state) => state.activeArt,
    }),
    API() {
      return this.$API;
    },
    filteredArt() {
      if (this.search || this.missingParent || this.missingLink) {
        let artWork = this.artWork;
        if (this.missingParent) {
          artWork = this.artWork.filter((art) => {
            return !art.hasParentStory;
          });
        }
        if (this.missingLink) {
          artWork = this.artWork.filter((art) => {
            return !art.link;
          });
        }
        if (this.missingLink && this.missingParent) {
          artWork = this.artWork.filter((art) => {
            return !art.link && !art.hasParentStory;
          });
        }
        if (this.search) {
          artWork = artWork.filter((art) => {
            return art.title.toLowerCase().includes(this.search.toLowerCase());
          });
        }
        return artWork;
      }
      return this.artWork;
    },
  },
  created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/admin/login');
    } else {
      this.getArt();
    }
  },
  methods: {
    ...mapActions([
      'setActiveArt',
    ]),
    getArt() {
      this.axios.get(`${this.$API}/arts-stripped?_sort=title:ASC&_limit=-1`).then((response) => {
        this.artWork = response.data;
        if (this.activeArt == null) {
          this.setActiveArt(this.artWork[0]);
        }
        this.artWork.forEach((art) => {
          if (art.tags) {
            return;
          } else {
            art.tags = [];
          }
        });
      });
    },
    closeModal() {
      this.getArt();
      this.showNewArtModal = false;
    },
  },
};
</script>
